import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin: 32px 0;
`;

const Input = styled.input`
  width: 100%;
  max-width: 300px;
  padding: 16px 20px;
  border: 2px solid var(--zyvgo-border, #e1e5e9);
  border-radius: var(--zyvgo-radius-sm, 6px);
  font-size: 1.125rem;
  font-family: var(--zyvgo-font-family);
  color: var(--zyvgo-text-primary, #222222);
  background-color: #FFFFFF;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: var(--zyvgo-primary, #222222);
    box-shadow: 0 0 0 3px rgba(34, 34, 34, 0.1);
  }
  
  &::placeholder {
    color: #999999;
  }
`;

const ErrorMessage = styled.div`
  color: var(--zyvgo-error, #e74c3c);
  font-size: 0.875rem;
  margin-top: 12px;
  font-weight: 500;
`;

const NumberInput = ({ question, value, onChange, error }) => {
  const handleChange = (inputValue) => {
    const numericValue = inputValue === '' ? '' : parseFloat(inputValue);
    onChange(numericValue);
  };

  return (
    <Container>
      <Input
        type="number"
        value={value ?? ''}
        onChange={(e) => handleChange(e.target.value)}
        placeholder="161"
        min={question.validation_rules?.min_value}
        max={question.validation_rules?.max_value}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};

export default NumberInput;
